<!--单据合同-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :editable="false"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        border
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #changeType="{row}">
          <div v-for="item in changeTypeStatus" :key="item.id">
            <div v-if="row.changeType.toString() === item.value">{{item.label}}</div>
          </div>
        </template>
        <template #status="{row}">
          <el-tag v-if="row.status === 0">未审批</el-tag>
          <el-tag v-if="row.status === 1" type="success">已通过</el-tag>
          <el-tag v-if="row.status === 2" type="danger">未通过</el-tag>
        </template>
        <template #toolbar="scope">
          <el-popover
            :ref="scope.row.id + 'b'"
            v-if="scope.row.status === 0"
            placement="top"
            width="180"
          >
            <p>确定要审批通过吗</p>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="$refs[scope.row.id + 'b'].doClose()"
                >取消</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click="audit(scope.row.id, 1)"
                >确定
              </el-button>
            </div>
            <el-button
              type="success"
              size="mini"
              slot="reference"
              >审批通过</el-button
            >
          </el-popover>
          <el-popover
            :ref="scope.row.id + 'b'"
            v-if="scope.row.status === 0"
            placement="top"
            width="180"
          >
            <p>确定要拒绝吗</p>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="$refs[scope.row.id + 'b'].doClose()"
                >取消</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="audit(scope.row.id, 2)"
                >确定</el-button>
            </div>
            <el-button
              type="warning"
              size="mini"
              slot="reference"
              >拒绝</el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { tableSataus } from '@/views/bill/mixins/status'
import { updateMilestonePlanChange } from '@/api/bill/milestonePlanChange'
import initDict from "@/mixin/initDict";

export default {
  name: "MilestonePlanChange",
  components: {
    DynamicSearch
  },
  mixins: [DataTableMixin, tableSataus, initDict],
  data () {
    return {
      changeTypeStatus: [],
      tableHead: [
        {
          label: '申请时间',
          prop: "created",
          width: '140'
        },
        {
          label: '申请人',
          prop: "creatorName",
          width: '120'
        },
        {
          label: "项目名称",
          prop: "projectName",
          width: '120',
          query: {
            type: "input"
          },
        },
        {
          label: "立项编号",
          prop: "projectNumber",
          width: '120',
          query: {
            type: "input"
          },
        },
        {
          label: "阶段名称",
          prop: "milestoneName",
          width: '120',
          query: {
            type: "input"
          },
        },
        {
          label: "调整类型",
          prop: "changeType",
          width: '100',
        },
        {
          label: "预计开始时间",
          prop: "expectedStartTime",
          width: '120'
        },
        {
          label: "预计完成时间",
          prop: "latestFinishTime",
          width: '120'
        },
        {
          label: "调整计划开始时间",
          prop: "changeStartTime",
          width: '145'
        },
        {
          label: "调整计划完成时间",
          prop: "changeFinishTime",
          width: '145'
        },
        {
          label: "调整原因",
          prop: "reason",
          sortable: false,
          width: '120'
        },
        {
          label: "审批状态",
          prop: "status",
          width: '100'
        }
      ]
    }
  },
  created () {
    this.$nextTick(() => {
      this.dataTableInit()
      // 调整类型
      this.getDict("change_type").then(res => {
        this.changeTypeStatus = res.data
        console.log(this.changeTypeStatus)
      });
    });
  },
  methods: {
    dataTableBeforeInit () {
      this._url = "/projectMilestonePlanChange"
      const params = { page: this.page, size: this.offset }
      this._params = Object.assign(params, this._query)
      return true
    },
    audit(id, status) {
      var params = {
        id: id,
        status: status
      }
      updateMilestonePlanChange(params).then(res => {
        this.dataTableInit()
        if (res.code === 200) {
          this.$notify({ title: "审批成功", type: "success", duration: 2500})
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
